module.exports = __webpack_public_path__ + "img/eye-slashed.48227e59.svg";